import { useSelector } from "react-redux";
import HomePageContentAPICall from "src/service/HomePageContentAPICall";
import store from "src/storeWire";
import {
    getAllTabsCount,
    getArticleList,
    getContentTabCount,
    getDocumentList,
    getDocumentListAutosuggest,
    getVideoList,
    getNpiList
} from "../store/slice/model/HomePageContent"

export function useHomePageContentStore() {
    const contentCount = useSelector((state) => state.entities.model_HomePageContent.contentCount)
    const allTabsCount = useSelector((state) => state.entities.model_HomePageContent.allTabsCount)
    const contentTabCount = useSelector((state) => state.entities.model_HomePageContent.contentTabCount)
    const contentList = useSelector((state) => state.entities.model_HomePageContent.contentList)
    const documentContentAutosuggestList = useSelector((state) => state.entities.model_HomePageContent.documentContentAutosuggest.list)
    const documentContentList = useSelector((state) => state.entities.model_HomePageContent.documentContent.list)
    const documentContentFacets = useSelector((state) => state.entities.model_HomePageContent.documentContent.facets)
    const documentContentCount = useSelector((state) => state.entities.model_HomePageContent.documentContent.count)
    const articleList = useSelector((state) => state.entities.model_HomePageContent.contentList.articleList)
    const videoList = useSelector((state) => state.entities.model_HomePageContent.contentList.videoList)

    let data = {
        documentContentAutosuggestList,
        documentContentFacets,
        documentContentList,
        documentContentCount,
        contentCount,
        allTabsCount,
        contentTabCount,
        contentList,
        articleList,
        videoList
    };

    let fetch = {
        get_content_tab_count: async (params) => {
            return await store.dispatch(getContentTabCount({ searchParam: params }))
        },
        get_all_tab_count: async (params) => {
            return await store.dispatch(getAllTabsCount(params))
        },
        get_document_list: async (search, page, limit, orderByDirection = "asc", orderBy = "DocumentType", selectedFilterList = [], dateRangeObject) => {
            return await store.dispatch(getDocumentList({
                search,
                page,
                limit,
                orderByDirection,
                orderBy,
                selectedFilterList,
                dateRangeObject
            }))
        },
        get_document_list_autosuggest: async (search, page, limit, orderByDirection = "asc", orderBy = "DocumentType", selectedFilterList = [], dateRangeObject) => {
            return await store.dispatch(getDocumentListAutosuggest({
                search,
                page,
                limit,
                orderByDirection,
                orderBy,
                selectedFilterList,
                dateRangeObject
            }))
        },
        get_all_content_list: async (params) => {
            let res = await new HomePageContentAPICall().getAllContentList(params)
            let result = {}
            result.data = res.data;
            return result
        },
        get_all_content_video_list: async (params) => {
            let res = await new HomePageContentAPICall().getAllContentVideoList(params)
            let result = {}
            result.data = res.data;
            return result
        },
        get_article_list: async (params) => {
            return await store.dispatch(getArticleList(params))
        },
        get_video_list: async (params) => {
            return await store.dispatch(getVideoList(params))
        },
        get_event_list: async (params) => {
            let res = await new HomePageContentAPICall().getEventsList(params.page, params.limit, params.sort, params.searchParam)
            let result = {}
            result.data = res.data;
            return result
        },
        get_site_page_list: async (params) => {
            let res = await new HomePageContentAPICall().getSitePagesContentList(params.page, params.limit, params.sort, params.searchParam)
            let result = {}
            result.data = res.data;
            return result
        },
        get_npi_list: async (params) => {
            // DT - 12/9/23 Bug 13142: Performance - Search: 2 Search API calls made
            let res =  await store.dispatch(getNpiList(params))
            // let res = await new HomePageContentAPICall().getNPIListBySearchParam(params.page, params.limit, params.sort, params.searchParam)
            let result = {}
            result.data = res.payload.data;
            return result
        }
    };
    let set = {};
    return [data, fetch, set]
}